import { Builder } from '@builder.io/react';

import SimpleCenteredHero from './index';

Builder.registerComponent(SimpleCenteredHero, {
  name: 'SimpleCenteredHero',
  inputs: [
   {
     name: 'title',
     type: 'string'
   },
   {
     name: 'subtitle',
     type: 'longText'
   },
   {
    name: 'icon',
    type: 'object', 
    subFields: [
      {
        name: 'src',
        type: 'file',
        allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg']
      },
      {
        name: 'alt',
        type: 'string'
      },
    ]
   },
   {
     name: 'webgl',
     type: 'boolean',
     defaultValue: 'false'
   },
   {
    name: 'cta',
    type: 'object',
    subFields: [
      {
        name: 'buttons',
        type: 'list',
        defaultValue: [
          {
            text: 'Talk to us',
            href: '/sales',
            variant: 'primary'
          }
        ],
        subFields: [
          {
            name: 'text',
            type: 'string'
          },
          {
            name: 'href',
            type: 'url'
          },
          {
            name: 'variant',
            type: 'string',
            defaultValue: 'primary',
            enum: ['primary', 'secondary', 'inverted']
          }
        ]
      },
    ]
  },
  ]
});